import { CSSProperties, FC, ReactNode } from 'react';
// styles
import styles from './MessageWrapperWithFadeOut.module.css';

interface IMessageWrapperWithFadeOutProps {
    children: ReactNode;
    customStyles?: CSSProperties;
    fadeOut: boolean;
    handleFinishFadeOut: () => void;
}

const MessageWrapperWithFadeOut: FC<IMessageWrapperWithFadeOutProps> = ({
    children,
    customStyles = {},
    fadeOut,
    handleFinishFadeOut,
}) => {
    return (
        <div
            className={`${styles['messageContainer']} ${fadeOut ? styles['fade-out'] : ''}`}
            style={customStyles}
            onAnimationEnd={() => handleFinishFadeOut && handleFinishFadeOut()}
        >
            {children}
        </div>
    );
};

export default MessageWrapperWithFadeOut;
